function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { j as o } from "./index.es33.js";
import { t as n } from "./index.es106.js";
import { clsx as s } from "./index.es105.js";
import "./index.es93.js";
import "./index.es94.js";
import "./index.es95.js";
import "./index.es96.js";
import "./index.es97.js";
import "./index.es98.js";
import "./index.es99.js";
import "./index.es100.js";
import "./index.es101.js";
import "./index.es102.js";
import "./index.es103.js";
import "./index.es104.js";
import { palette as a } from "./index.es36.js";
import { Icon as i } from "./index.es7.js";
import { PositionVariants as l } from "./index.es172.js";
import { Tooltip as c } from "./index.es13.js";
import "react";
import "nanoid";
import "./index.es15.js";
import r from "./index.es564.js";

var P = function P(_ref) {
  var t = _ref.isDisabled,
      m = _ref.isActive,
      p = _ref.onClick;
  return o.jsx(c, {
    isVisibleDisabled: t,
    position: l.underCenter,
    title: n("component_component_variableIcon_variableIconTooltipLabel"),
    children: o.jsx("button", {
      type: "button",
      disabled: t,
      className: s(r.variableBtn, _defineProperty({}, r.active, m)),
      onMouseDown: function onMouseDown(e) {
        return e.preventDefault();
      },
      onClick: p,
      children: o.jsx(i, {
        size: 16,
        color: a.gray6,
        icon: i.icons.system.s.utilities.variable
      })
    })
  });
};

export { P as VariableIcon };